module.exports = __webpack_public_path__ + "img/Exsellance_Logo_Transparent_1.a49342f1.png";